import { trackEvent } from './track-event'

export function trackPartnerProfileExperienceClick(
  merchantPublicId: number,
  experiencePublicId: number
) {
  trackEvent({
    event: 'partner_profile_experience_click',
    merchant_public_id: merchantPublicId,
    experience_public_id: experiencePublicId,
  })
}
